import Controller from '@ember/controller';
import { ApplicationModel } from 'login/routes/application';

export default class ExpiredController extends Controller<ApplicationModel> {}
